import { ListItemIcon, styled } from '@mui/material'

import { MenuItem, MenuItemProps, Typography } from '@carto/meridian-ds/components'

const IconWrapper = styled(ListItemIcon)(({ theme }) => ({
  '.MuiButtonBase-root &': {
    margin: 0,
    marginRight: theme.spacing(1),
    minWidth: theme.spacing(2.25)
  }
}))

type ActionProps = MenuItemProps & { component: string }
const MenuItemAction = styled(MenuItem)<ActionProps>(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  width: '100%'
}))

function UserAction({
  icon,
  text,
  color,
  onClick
}: {
  icon: React.ReactNode
  text: React.ReactNode
  color?: string
  onClick: () => void
}) {
  return (
    <MenuItemAction component="button" onClick={onClick} iconColor="default">
      <IconWrapper>{icon}</IconWrapper>
      <Typography variant="body2" color={color}>
        {text}
      </Typography>
    </MenuItemAction>
  )
}

export default UserAction
